import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
import Cookies from 'js-cookie';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    dark: null
  },
  mutations: {
    mutationDark(state, data) {
      state.dark = data;
    },
  },
  actions: {},
  modules: {},
  plugins: [createPersistedState({
    storage: {
      getItem: key => Cookies.get(key),
      setItem: (key, value) => Cookies.set(key, value, {expires: 3, secure: true}),
      removeItem: key => Cookies.remove(key)
    }
  })],
});
